import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {

  private currencyMap: { [key: string]: string } = {
    USD: '$', // United States Dollar
    INR: '₹', // Indian Rupee
    EUR: '€', // Euro
    GBP: '£', // British Pound
    JPY: '¥', // Japanese Yen
    AUD: '$', // Australian Dollar
    CAD: '$', // Canadian Dollar
    CNY: '¥', // Chinese Yuan
    SGD: '$', // Singapore Dollar
    MXN: '$', // Mexican Peso
    BRL: '$', // Brazilian Real
    ZAR: 'R', // South African Rand
    RUB: '₽', // Russian Ruble
    KRW: '₩', // South Korean Won
    SEK: 'kr', // Swedish Krona
    NOK: 'kr', // Norwegian Krone
    DKK: 'kr', // Danish Krone
    CHF: 'Fr.', // Swiss Franc
    NZD: 'NZ$', // New Zealand Dollar
    PHP: '₱', // Philippine Peso
    TRY: '₺', // Turkish Lira
    IDR: 'Rp', // Indonesian Rupiah
    ARS: '$', // Argentine Peso
    COP: '$', // Colombian Peso
    KES: 'KSh', // Kenyan Shilling
    UAH: '₴', // Ukrainian Hryvnia
    VND: '₫', // Vietnamese Dong
    BGN: 'лв', // Bulgarian Lev
    MYR: 'RM', // Malaysian Ringgit
    THB: '฿', // Thai Baht
    ILS: '₪', // Israeli New Shekel
    LKR: 'Rs', // Sri Lankan Rupee
    TWD: 'NT$', // Taiwan Dollar
    HUF: 'Ft', // Hungarian Forint
    PKR: 'Rs', // Pakistani Rupee
    CLP: '$', // Chilean Peso
    EGP: '£', // Egyptian Pound
    MAD: 'د.م.', // Moroccan Dirham
    SAR: 'ر.س', // Saudi Riyal
    KWD: 'د.ك', // Kuwaiti Dinar
    JOD: 'د.ا', // Jordanian Dinar
    OMR: 'ر.ع.', // Omani Rial
    QAR: 'ر.ق', // Qatari Rial
    BDT: '৳', // Bangladeshi Taka
    CUC: '$', // Cuban Convertible Peso
    LBP: 'ل.ل', // Lebanese Pound
    VEF: 'Bs', // Venezuelan Bolívar
    KZT: '〒', // Kazakhstani Tenge
    AZN: '₼', // Azerbaijani Manat
    IQD: 'د.ع', // Iraqi Dinar
    MNT: '₮', // Mongolian Tugrik
    LTL: 'Lt', // Lithuanian Litas
    GEL: 'ლ', // Georgian Lari
    HRK: 'kn', // Croatian Kuna
    RON: 'lei', // Romanian Leu
    BYN: 'Br', // Belarusian Ruble
    RSD: 'дин.', // Serbian Dinar
    MKD: 'ден', // Macedonian Denar
    MZN: 'MT', // Mozambican Metical
    NPR: 'रु', // Nepali Rupee
    MOP: 'P', // Macanese Pataca
    YER: '﷼', // Yemeni Rial
    LSL: 'M', // Lesotho Loti
    MUR: '₨', // Mauritian Rupee
    KGS: 'som', // Kyrgyzstani Som
    AFN: '؋', // Afghan Afghani
    BMD: '$', // Bermudian Dollar
    TND: 'د.ت', // Tunisian Dinar
    KMF: 'CF', // Comorian Franc
    GMD: 'D', // Gambian Dalasi
    STN: 'Db', // São Tomé and Príncipe Dobra
    UGX: 'USh', // Ugandan Shilling
    BOB: 'Bs', // Bolivian Boliviano
    SZL: 'E', // Swazi Lilangeni
    FJD: '$', // Fijian Dollar
    WST: 'T', // Samoan Tala
    XOF: 'XOF', // West African CFA Franc
    XPF: 'XPF', // CFP Franc
    TJS: 'SM', // Tajikistani Somoni
    TMT: 'm', // Turkmenistani Manat
    ERN: 'Nkf', // Eritrean Nakfa
    GNF: 'FG', // Guinean Franc
    SLL: 'Le', // Sierra Leonean Leone
    MWK: 'MK', // Malawian Kwacha
    ZMW: 'ZK', // Zambian Kwacha
    KHR: '៛', // Cambodian Riel
    MMK: 'K', // Myanmar Kyat
    ZWL: '$', // Zimbabwean Dollar
    KPW: '₩', // North Korean Won
    CDF: 'FC', // Congolese Franc
    BTN: 'Nu.', // Bhutanese Ngultrum
    FKP: '£', // Falkland Islands Pound
    MDL: 'L', // Moldovan Leu
    BIF: 'FBu', // Burundian Franc
    AED: 'AED', // UAE Dirham

  };

  transform(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const str = String(value).trim();
    return this.currencyMap[str] || this.currencyMap[str.toUpperCase()] || str;
  }

}
